import { DeviceEnrollment } from '@/types/utilityProgramEnrollment'
import { useState } from 'react'
import { EnrollmentRoot } from '@/types/programs-new/programs-new'
import useApiDispatch from '@/hooks/useApiDispatch/useApiDispatch'
import {
  createDeviceEnrollmentAction,
  toggleProgramEnrollmentAction,
} from '@/utils/utility-program-helpers/utilityProgramHelpers'
import { programsNewCollection } from '@/reducers/programsNew'
import { DeviceType } from '@/app/components/DeviceSelectionGallery/DeviceSelectionGallery.types'

export const isDeviceEnrolled = (enrollment: EnrollmentRoot | null) =>
  enrollment ? !enrollment.unenrolled_at : false

type Props = {
  enrollment: EnrollmentRoot | null
  onChange?: (enrollment: EnrollmentRoot | null) => void
  onSuccess: (enrollment: DeviceEnrollment) => void
  onError: (error: string) => void
  showConfirmationModal: () => void
  utilityProgramId: number
  deviceId: string | number
  deviceType: DeviceType
}

export function useViewModel(props: Props) {
  const { apiDispatch } = useApiDispatch()
  const [isUpdating, setIsUpdating] = useState(false)
  const { isLoadingOrIdle: programsNewIsLoadingOrIdle } =
    programsNewCollection.useFetch()

  const { enrollment, onChange, onError, onSuccess, showConfirmationModal } =
    props

  const updateEnrollment = async () => {
    setIsUpdating(true)

    const action = enrollment
      ? toggleProgramEnrollmentAction(enrollment)
      : createDeviceEnrollmentAction(
          props.deviceType,
          props.utilityProgramId,
          props.deviceId,
        )

    if (!action) {
      setIsUpdating(false)
      return
    }

    const promise = apiDispatch<DeviceEnrollment>(action)

    if (!promise) {
      return
    }

    const res = await promise
    setIsUpdating(false)

    if (!res.ok) {
      onError(res.error.message)
    } else {
      onSuccess(res.data)
    }
  }

  const onToggle = () => {
    if (isDeviceEnrolled(enrollment)) {
      showConfirmationModal()
    } else {
      updateEnrollment()
    }
    onChange?.(enrollment)
  }

  return {
    isUpdating: isUpdating || programsNewIsLoadingOrIdle,
    updateEnrollment,
    onToggle,
  }
}
